import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=0b08ba82"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=0b08ba82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports